import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashNav from "../../Components/DashNav/DashNav";
import Gbtn from "../../Components/buttons/Gbtn";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import InputField from "../../Components/InputField/InputField";
import { deleteAboutContent, postServices } from "../../api";
import { getImageUrl } from "../../helpers/getImageUrl";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import "animate.css";
import JoditEditor from "jodit-react";
import { BiSolidExtension } from "react-icons/bi";
import { GoCopy } from "react-icons/go";


export default function TeamAddEdit({ isEdit, isDelete }) {
    const icon = () => {
        return <BiSolidExtension size="26" fill="#DF2F35" />;
    };

    const location = useLocation();
    const prevData =
        location.state && location.state ? location.state.editData : null;
    const page = location.state && location.state ? location.state.page : null;

    let baseUrl = process.env.REACT_APP_BASE_URL;
    const editor = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [profileImage, setProfileImage] = useState("");
    const [editImage, setEditImage] = useState(prevData?.image || "");
    const [imageErr, setImageErr] = useState(false);
    const [rangeText, setRangeText] = useState("");
    const [errMsg, setErrMsg] = useState("");
    const [err, setErr] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [nameErr, setNameErr] = useState(false);
    const [updatedData, setUpdatedData] = useState({
        id: prevData ? prevData.id : 0,
        name: prevData ? prevData.name : "",
        description: prevData ? prevData.description : "",
        scope: prevData?.scope ?? false,
        service_ranges: prevData ? prevData.service_ranges : [],
    });

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    useEffect(() => {
        Modal.setAppElement("#root");
    }, []);

    const navigate = useNavigate();

    const saveOnclick = () => {
        if (!updatedData.name) setNameErr(true);
        else {
            setIsLoading(true);
            setErr(false);

            const data = new FormData();
            data.append("id", updatedData.id);
            data.append("name", updatedData.name);
            data.append("description", updatedData.description);
            data.append("scope", updatedData.scope);
            updatedData.service_ranges.forEach((range, index) => {
                data.append(`service_ranges[${index}].id`, range?.id ? range.id : 0);
                data.append(`service_ranges[${index}].service_id`, updatedData?.id ? updatedData.id : 0);
                data.append(`service_ranges[${index}].description`, range.description);
            });
            if (profileImage instanceof File) {
                data.append("image", profileImage, profileImage.name);
            } else if (editImage) {
                data.append("image", editImage);
            }

            postServices(data)
                .then(({ data }) => {
                    setIsLoading(false);
                    if (data.error_code == 0 || data.error_code == 1) {
                        navigate("/dashboard/services", {
                            state: { page: page },
                        });
                    } else {
                        setErr(true);
                        setErrMsg(data.message);
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    setErr(true);
                    setErrMsg("Some error occured. Please check your network connection.");
                });
        }
    };

    const deleteOnclick = () => {
        setModalIsOpen(true);
    };
    const deleteClick = () => {
        let obj = {
            id: prevData ? prevData.id : null,
        };
        deleteAboutContent(obj)
            .then(({ data }) => {
                setErr(false);
                setIsLoading(true);
                if (data.success) {
                    setModalIsOpen(false);
                    setIsLoading(false);
                    navigate("/dashboard/about", {
                        state: { page: page },
                    });
                } else {
                    setErr(true);
                    setErrMsg(data.message);
                }
            })
            .catch((Err) => {
                console.log("Delete role Error: ", Err);
                setErrMsg(err.message);
                setModalIsOpen(false);
                setErr(true);
                setIsLoading(false);
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedData({ ...updatedData, [name]: value });
    };

    const onSelectImage = (img) => {
        if (
            img.type.includes("png") ||
            img.type.includes("jpg") ||
            img.type.includes("jpeg")
        ) {
            setProfileImage(img);
            setImageErr(false);
            setEditImage("");
        } else {
            alert("Invalid File!");
        }
    };

    const handleImageErr = () => {
        setImageErr(true);
    };

    const removeImage = () => {
        setProfileImage("");
        setEditImage("");
    };

    const imagePreview = profileImage instanceof File
        ? URL.createObjectURL(profileImage)
        : editImage
            ? getImageUrl(baseUrl, editImage)
            : "";

    return (
        <>
            <Modal
                isOpen={modalIsOpen}
                className="deleteModal animate__animated animate__zoomIn"
                style={{ display: "flex" }}
            >
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <div
                            className="delClient-cross"
                            onClick={(e) => {
                                setModalIsOpen(false);
                            }}
                        >
                            <RxCross2 color="white" size={"20"} />
                        </div>
                        <>
                            <h3 style={{ color: "white", marginBottom: "60px" }}>
                                Are you sure you want to delete?
                            </h3>

                            <Gbtn
                                text="Delete"
                                color="#EE282E"
                                radius="6px"
                                width="40%"
                                func={deleteClick}
                            />
                        </>
                    </>
                )}
            </Modal>

            <div className="mainDashView">
                <div>
                    <DashNav svg={icon} DashboardNavText={"Services"} />
                </div>
                <div className="dashPanel" style={{ position: "relative" }}>
                    <>
                        <div className="ar-dashpanel">
                            <h4
                                style={{
                                    display: err ? "flex" : "none",
                                    justifyContent: "center",
                                    color: "red",
                                    position: "absolute",
                                    top: "0",
                                    width: "90%",
                                }}
                            >
                                <p>Error! {errMsg}.</p>
                            </h4>
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                    }}
                                >
                                    <LoadingSpinner />
                                </div>
                            ) : (
                                <div style={{ flex: 1 }}>
                                    <div >
                                        <div className="ae-formFields">
                                            <div className="ae-inputField">
                                                <InputField
                                                    name={"name"}
                                                    isErr={nameErr}
                                                    errorMsg="Title is required"
                                                    required={true}
                                                    value={updatedData ? updatedData.name : null}
                                                    onChange={(e) => {
                                                        setNameErr(false);
                                                        handleChange(e);
                                                    }}
                                                    placeholder={"Title"}
                                                    radius="5px"
                                                />
                                            </div>
                                            <div className="ae-inputField" style={{ marginTop: "20px" }}>
                                                <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={updatedData.scope}
                                                        onChange={(e) => setUpdatedData({
                                                            ...updatedData,
                                                            scope: e.target.checked,
                                                        })}
                                                    />
                                                    <span className="if-txt">Scope</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div style={{ margin: "50px 0", width: '90%' }}>
                                            <p className="if-txt">Description</p>
                                            <JoditEditor
                                                ref={editor}
                                                value={updatedData.description}
                                                onBlur={(newContent) => setUpdatedData({
                                                    ...updatedData,
                                                    description: newContent,
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="files-inputs-container">
                                        <div className="file-input">
                                            <div>
                                                <div className="if-txt" style={{ marginTop: "40px" }}>
                                                    Add Image
                                                </div>
                                                <div className="Add_Client_Image_container">
                                                    <label className="changeimage-label">
                                                        <div className="AddimageBtn">
                                                            <span className="cam_Image_upload">+</span>
                                                            <div>
                                                                <input
                                                                    type="file"
                                                                    className="formuploadimage_input"
                                                                    accept=".png, .jpg, .jpeg"
                                                                    onChange={(e) => onSelectImage(e.target.files[0])}
                                                                    onClick={(event) => (event.currentTarget.value = null)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {imagePreview && !imageErr && (
                                            <div className="image_container">
                                                <div className="Add_Client_Image_container news_image">
                                                    <label className="changeimage-label">
                                                        <img
                                                            src={imagePreview}
                                                            onError={handleImageErr}
                                                            alt="service"
                                                            height="120px"
                                                            width="120px"
                                                            className="add-image-Style"
                                                        />
                                                    </label>
                                                    <div
                                                        className="images_cross"
                                                        onClick={removeImage}
                                                    >
                                                        <RxCross2 size={15} color="white" />
                                                    </div>
                                                </div>
                                                {editImage && (
                                                    <div
                                                        className="images_link"
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(getImageUrl(baseUrl, editImage));
                                                        }}
                                                    >
                                                        {getImageUrl(baseUrl, editImage).substring(0, 22)}
                                                        <span className="images_link_copy">
                                                            <GoCopy size={18} />
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div>
                                        <div
                                            className="ae-formFields"
                                            style={{
                                                alignItems: "flex-end",
                                            }}
                                        >
                                            <div className="ae-inputField" >
                                                <InputField
                                                    cat="Range"
                                                    name={"range"}
                                                    errorMsg="Range is required"
                                                    value={rangeText ? rangeText : ''}
                                                    onChange={(e) => {
                                                        setRangeText(e.target.value);
                                                    }}
                                                    placeholder="Write range text"
                                                />
                                            </div>
                                            <Gbtn
                                                text="Add"
                                                disabled={rangeText ? false : true}
                                                radius="5px"
                                                width="100px"
                                                marginTop="40px"
                                                func={() => {
                                                    if (rangeText) {
                                                        let range = {
                                                            id: 0,
                                                            service_id: updatedData?.id,
                                                            description: rangeText,
                                                        };
                                                        let newArr = [...updatedData.service_ranges, range]
                                                        setUpdatedData((prev) => ({ ...prev, service_ranges: newArr }));
                                                        setRangeText("");
                                                    }
                                                }}
                                            />
                                        </div>
                                        {updatedData.service_ranges?.length > 0 ?
                                            <div>
                                                <div className="if-txt">Ranges</div>
                                                <div>
                                                    <table style={{ minWidth: "60%" }}>
                                                        <tr>
                                                            <th style={{ padding: "10px" }}>Sr No.</th>
                                                            <th style={{ padding: "10px" }}>Description</th>
                                                            <th style={{ padding: "10px" }}>Action</th>
                                                        </tr>
                                                        {updatedData.service_ranges?.map((range, index) => (
                                                            <>
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td>{range.description}</td>
                                                                    <td className="cursor" onClick={() => {
                                                                        const updatedRanges = [...updatedData.service_ranges];
                                                                        updatedRanges.splice(index, 1);
                                                                        setUpdatedData((prev) => ({ ...prev, service_ranges: updatedRanges }));
                                                                    }}>Remove</td>
                                                                </tr>
                                                            </>
                                                        ))}
                                                    </table>
                                                </div>
                                            </div> : null}
                                    </div>

                                </div>
                            )}
                            <div className="addEdit-btns">
                                <div className="ev-btnAdd ev-btn">
                                    <Gbtn
                                        text={isEdit ? "Update" : isDelete ? "Delete" : "Add"}
                                        func={isDelete ? deleteOnclick : saveOnclick}
                                        disabled={isLoading}
                                        color="#DF2F35"
                                        radius="5px"
                                        width="150px"
                                    />
                                </div>
                                <div className="ev-btnDel ev-btn">
                                    <Gbtn
                                        text={isEdit ? "Discard" : "Back"}
                                        color="#0061B1"
                                        func={() =>
                                            navigate("/dashboard/services", {
                                                state: { page: page },
                                            })
                                        }
                                        radius="5px"
                                        width="150px"
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </>
    );
}

